/* The cart page's behaviour. Markup in sections/sjt-cart.liquid, styles in
   assets/sjt-cart.css. The drawer's own behaviour is in assets/sjt-drawer.js.
 *
 * NOTHING HERE PRINTS A STOCK CLAIM. Sujatra sells on CONTINUE, so "out of
 * stock" is never true enough to say. A size that exists is offered; that is
 * the whole rule.
 */
(function () {
  'use strict';

  /* Loaded by the cart section AND, for the drawer, on every page. Two copies
     would bind every document listener twice and add two of everything. */
  if (window.SjtCart && window.SjtCart.loaded) return;
  window.SjtCart = { loaded: true };

  /* Delegated from the DOCUMENT, not from one root. The same markup is served
     to the cart page and -- via ?section_id -- into the drawer, where it arrives
     long after load. A listener bound to a root that did not exist yet is a
     drawer whose buttons do nothing. */

  /* ── adding ─────────────────────────────────────────────────────────────── */

  /* The PDP's bundle flow stamps a child with its parent's SKU under
     properties["With Product"] and groups a bundle under `unique`
     (layout/theme.liquid). The cart adds the same pieces, so it says the same
     thing -- otherwise a pant bought from the cart reaches the order with
     nothing linking it to the kurta it belongs to. */
  function parentProps(btn) {
    var set = btn && btn.closest ? btn.closest('[data-sjc-set]') : null;
    var sku = set && set.getAttribute('data-sjc-parent');
    if (!sku) return null;
    /* `unique` is what ties a bundle together -- cart.js groups on it. Reuse the
       parent line's stamp when it has one, so a pant added here joins the kurta
       it belongs to instead of starting a group of one. */
    var group = (set.getAttribute('data-sjc-unique') || '').trim();
    return { 'With Product': sku, unique: group || String(Date.now()) };
  }

  function add(items, btn, done) {
    var was = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      /* The page is server-rendered from the cart, so the honest way to show a
         new line is to re-read it rather than patch six numbers by hand and hope
         they agree with the totals. */
      if (done) done();
      else if (document.querySelector('.sjd.is-open')) window.SjtCart.refresh();
      else window.location.reload();
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
      window.setTimeout(function () { if (btn) btn.textContent = was; }, 2200);
    });
  }

  /* A size row: the chosen button, or the only one when there is just one. */
  function chosenVariant(scope) {
    var on = scope.querySelector('[data-sjc-size][aria-pressed="true"]');
    if (on) return on.getAttribute('data-sjc-size');
    var all = scope.querySelectorAll('[data-sjc-size]');
    return all.length === 1 ? all[0].getAttribute('data-sjc-size') : '';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-sjc]')) return;
    var size = e.target.closest('[data-sjc-size]');
    if (size) {
      /* The picker overlays a linked photo. Bed, 4 Oct 2026: "i tried adding
         some thing from bottom it took me to the product instead of adding". */
      e.preventDefault();
      var row = size.closest('[data-sjc-row]') || size.closest('[data-sjc-card]');
      if (row) {
        row.querySelectorAll('[data-sjc-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === size ? 'true' : 'false');
        });
        /* In the rail the sizes sit over the photo and adding is the next tap,
           so choosing one IS the add. In a cart line the Add button is already
           on screen and pressing a size should not buy anything. */
        if (row.hasAttribute('data-sjc-card')) {
          add([{ id: Number(size.getAttribute('data-sjc-size')), quantity: 1 }], null);
        }
      }
      return;
    }

    var one = e.target.closest('[data-sjc-add]');
    if (one) {
      var r = one.closest('[data-sjc-row]');
      var v = r ? chosenVariant(r) : one.getAttribute('data-sjc-add');
      if (!v) {
        var ask = r && r.querySelector('[data-sjc-size]');
        if (ask) { ask.focus(); r.classList.add('sjc--asking'); }
        return;
      }
      var props = parentProps(one);
      var line = { id: Number(v), quantity: 1 };
      if (props) line.properties = props;
      add([line], one);
      return;
    }

    var both = e.target.closest('[data-sjc-both]');
    if (both) {
      var set = both.closest('[data-sjc-set]');
      var items = [];
      var missing = false;
      /* One `unique` for the pair: both children belong to the same parent and
         the same decision, which is what the bundle stamp is for. */
      var bprops = parentProps(both);
      set.querySelectorAll('[data-sjc-row]').forEach(function (r2) {
        var v2 = chosenVariant(r2);
        if (!v2) { missing = true; return; }
        var li2 = { id: Number(v2), quantity: 1 };
        if (bprops) li2.properties = bprops;
        items.push(li2);
      });
      if (missing || !items.length) {
        var a2 = set.querySelector('[data-sjc-size]');
        if (a2) a2.focus();
        return;
      }
      add(items, both);
      return;
    }

    var openPick = e.target.closest('[data-sjc-pick]');
    if (openPick) {
      e.preventDefault();
      var card = openPick.closest('[data-sjc-card]');
      var sizes = card && card.querySelector('[data-sjc-sizes]');
      if (sizes) {
        sizes.hidden = !sizes.hidden;
        openPick.textContent = sizes.hidden ? 'Add' : 'Pick a size';
        openPick.classList.toggle('sjc__sadd--picking', !sizes.hidden);
      }
      return;
    }

    var copy = e.target.closest('[data-sjc-copy]');
    if (copy) {
      var code = copy.getAttribute('data-sjc-copy');
      var label = copy.querySelector('i');
      var revert = label ? label.textContent : '';
      function flash(t) { if (label) { label.textContent = t; window.setTimeout(function () { label.textContent = revert; }, 1800); } }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { flash('copied'); }, function () { flash('select it'); });
      } else {
        /* Older iOS in particular. A selected code can still be copied by hand,
           which beats a button that silently does nothing. */
        var t = document.createElement('textarea');
        t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); flash('copied'); } catch (err) { flash('select it'); }
        document.body.removeChild(t);
      }
    }
  });

  /*
   * BACK TO WHERE THEY WERE, not to a generic collection. Bed, 4 Oct 2026: "how
   * do i go back to the PDP where i last was ?". The href is a real link so it
   * works without JS and reads sensibly to a crawler; when there IS history from
   * this site, it returns to the actual product page instead.
   */
  document.addEventListener('click', function (e) {
    var back = e.target.closest && e.target.closest('[data-sjc-back]');
    if (!back) return;
    var sameSite = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
    if (sameSite && window.history.length > 1) {
      e.preventDefault();
      window.history.back();
    }
  });

  /* ── the order note ─────────────────────────────────────────────────────── */

  /* Saved over /cart/update.js, not with the form: Razorpay intercepts the
     submit, so a note that only persists on a native submit would vanish for
     every Magic Checkout order -- which is most of them. */
  document.addEventListener('change', function (e) {
    var note = e.target.closest && e.target.closest('[data-sjc-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () { /* the note is a courtesy; never block checkout */ });
  });

  /* ── the rail ───────────────────────────────────────────────────────────── */

  var WANT = 10;
  var rail, IN_CART, MONEY;

  function money(paise) {
    var n = Math.round(paise / 100);
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, n.toLocaleString('en-IN'));
  }

  function savedRows() {
    var ids, meta;
    try { ids = JSON.parse(localStorage.getItem('sujatra:saved')) || []; } catch (e) { ids = []; }
    try { meta = JSON.parse(localStorage.getItem('sujatra:saved:meta')) || {}; } catch (e) { meta = {}; }
    return ids.slice().reverse().map(function (id) {
      var d = meta[id] || {};
      if (!d.h) return null;
      return { handle: d.h, title: d.t, price: d.p, image: d.i, vs: d.vs, saved: true };
    }).filter(Boolean);
  }

  function viewedHandles() {
    try { return JSON.parse(localStorage.getItem('recentlyViewed')) || []; } catch (e) { return []; }
  }

  function card(row) {
    var li = document.createElement('li');
    li.className = 'sjc__card';
    li.setAttribute('data-sjc-card', '');

    var shot = document.createElement('div');
    shot.className = 'sjc__cardshot';
    var link = document.createElement('a');
    link.className = 'sjc__cardlink';
    link.href = '/products/' + row.handle;
    var img = document.createElement('img');
    img.src = row.image || '';
    img.alt = row.title || '';
    img.loading = 'lazy';
    link.appendChild(img);
    shot.appendChild(link);
    var prov = document.createElement('i');
    prov.className = 'sjc__prov' + (row.saved ? ' sjc__prov--saved' : '');
    prov.textContent = row.saved ? 'saved' : 'viewed';
    shot.appendChild(prov);

    var vs = [];
    try { vs = JSON.parse(row.vs || '[]') || []; } catch (e) { vs = []; }
    if (vs.length) {
      var pick = document.createElement('div');
      pick.className = 'sjc__pick';
      pick.setAttribute('data-sjc-sizes', '');
      pick.hidden = true;
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-sjc-size', v.i);
        b.textContent = v.t;
        pick.appendChild(b);
      });
      shot.appendChild(pick);
    }
    li.appendChild(shot);

    var p = document.createElement('p');
    p.className = 'sjc__cardname';
    p.textContent = row.title || 'View this piece';
    li.appendChild(p);
    if (row.price) {
      var b2 = document.createElement('b');
      b2.className = 'sjc__cardprice';
      b2.textContent = row.price;
      li.appendChild(b2);
    }

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'sjc__sadd';
    if (vs.length > 1) {
      cta.setAttribute('data-sjc-pick', '');
      cta.textContent = 'Add';
    } else if (vs.length === 1) {
      cta.setAttribute('data-sjc-add', vs[0].i);
      cta.textContent = 'Add';
    } else {
      /* No variants in the snapshot. The product page is offered rather than a
         guess -- never a stock verdict, which CONTINUE makes unsupportable. */
      cta.setAttribute('data-sjc-view', row.handle);
      cta.textContent = 'View';
      cta.addEventListener('click', function () { window.location.href = '/products/' + row.handle; });
    }
    li.appendChild(cta);
    return li;
  }

  function render(rows) {
    var list = rail.querySelector('[data-sjc-track]');
    if (!rows.length) { rail.hidden = true; return; }
    rail.hidden = false;
    while (list.firstChild) list.removeChild(list.firstChild);
    rows.forEach(function (r) { list.appendChild(card(r)); });
  }

  /* Saved pieces carry a full snapshot and cost nothing to draw. Viewed pieces
     are handles only, so they are fetched -- lazily, and only for the slots the
     saved ones did not fill. The cart is the most conversion-sensitive page in
     the shop; it does not block on a request nobody asked for. */
  function topUp(rows, seen) {
    var want = WANT - rows.length;
    if (want <= 0) return;
    var pool = viewedHandles().filter(function (h) { return !seen[h]; }).slice(0, want);
    if (!pool.length) return;
    Promise.all(pool.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (got) {
      got.forEach(function (p) {
        if (!p || IN_CART.indexOf(String(p.id)) !== -1) return;
        var vs = [];
        (p.variants || []).forEach(function (v) { if (v.available) vs.push({ i: v.id, t: v.title }); });
        rows.push({
          handle: p.handle,
          title: p.title,
          price: money(p.price),
          image: p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_320x$1$2') : '',
          vs: JSON.stringify(vs),
          saved: false
        });
      });
      render(rows);
    });
  }

  function build(scope) {
    rail = (scope || document).querySelector('[data-sjc-rail]');
    if (!rail) return;
    IN_CART = (rail.getAttribute('data-in-cart') || '').split(',').filter(Boolean);
    MONEY = rail.getAttribute('data-money') || '₹{{amount}}';
    var seen = {};
    var rows = savedRows().filter(function (r) {
      if (seen[r.handle]) return false;
      seen[r.handle] = true;
      return true;
    });
    render(rows);
    /* Deferred so it never competes with the cart's own paint. */
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { topUp(rows, seen); });
    else window.setTimeout(function () { topUp(rows, seen); }, 400);
  }

  /* The drawer calls this after it injects the section. The cart page calls it
     once, for itself. */
  window.SjtCart.mount = build;

  build(document);
})();


/* ── DISMISSING A SET SUGGESTION ────────────────────────────────────────────
 *
 * Bed: "give opton to remove rhe suggestion in cart drawer".
 *
 * ⚠ sessionStorage, NOT localStorage. A suggestion declined today should be
 * offered again next time they shop; silencing it forever is a bigger
 * decision than tapping a small x.
 *
 * ⚠ AND REAPPLIED ON EVERY RE-RENDER. The cart replaces its own HTML whenever
 * a quantity changes, so a block hidden at load comes straight back. The
 * observer is what makes the dismissal stick for the visit.
 */
(function () {
  var KEY = 'sjcSetHidden';

  function hidden() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function remember(sku) {
    try {
      var list = hidden();
      if (list.indexOf(sku) < 0) list.push(sku);
      sessionStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function apply() {
    var list = hidden();
    if (!list.length) return;
    var sets = document.querySelectorAll('[data-sjc-set]');
    for (var i = 0; i < sets.length; i++) {
      var sku = sets[i].getAttribute('data-sjc-parent') || '';
      if (list.indexOf(sku) > -1) sets[i].hidden = true;
    }
  }

  /* ⚠ CAPTURE, NOT BUBBLE. The drawer injects this markup and runs its own
     delegated handlers; anything calling stopPropagation() on a click inside
     it silences every document-level listener registered the ordinary way.
     Capture runs first and cannot be cut off — which is why the button worked
     on the cart page and did nothing in the drawer. */
  document.addEventListener('click', function (e) {
    var x = e.target.closest ? e.target.closest('[data-sjc-setx]') : null;
    if (!x) return;
    e.preventDefault();
    e.stopPropagation();
    var set = x.closest('[data-sjc-set]');
    if (!set) return;
    remember(set.getAttribute('data-sjc-parent') || '');
    set.hidden = true;
  }, true);

  apply();
  document.addEventListener('DOMContentLoaded', apply);
  if (window.MutationObserver) {
    new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
